<p-button [rounded]="true" [text]="true" (click)="toggleMenu()">
  <mat-icon>menu</mat-icon>
</p-button>
